import { useState, useEffect } from 'react';
const TINY_SCREEN_BREAKPOINT = 340;
export function useIsTinyScreen() {
  const [isTinyScreen, setIsTinyScreen] = useState(() => typeof window === 'undefined' ? false : window.innerWidth < TINY_SCREEN_BREAKPOINT);
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${TINY_SCREEN_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsTinyScreen(window.innerWidth < TINY_SCREEN_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isTinyScreen;
}
